// @ts-ignore
import * as cornerstoneTools from "cornerstone-tools";
import { BaseAnnotationTool } from "cornerstone-tools";

export default class CornerstoneToolsWrapper {
  // @ts-ignore
  static BaseAnnotationToolClass: typeof BaseAnnotationTool = cornerstoneTools.import("base/BaseAnnotationTool");
  // @ts-ignore
  static getNewContext: (canvas) => CanvasRenderingContext2D = cornerstoneTools.import("drawing/getNewContext");
  static draw: (context: CanvasRenderingContext2D, fn: (context: CanvasRenderingContext2D) => any) => void =
    // @ts-ignore
    cornerstoneTools.import("drawing/draw");
  static drawRect: (
    context: CanvasRenderingContext2D,
    element: any,
    corner1: any,
    corner2: any,
    options: any,
    coordSystem: string
    // @ts-ignore
  ) => void = cornerstoneTools.import("drawing/drawRect");
  static drawHandles: (context: CanvasRenderingContext2D, evtDetail: any, handles: any, handleOptions: any) => void =
    // @ts-ignore
    cornerstoneTools.import("drawing/drawHandles");
  static handleActivator: (elt: any, handles: any, canvasPoint: any, distanceThreshold: number) => boolean =
    // @ts-ignore
    cornerstoneTools.import("manipulators/handleActivator");
  static getHandleNearImagePoint: (elt: any, handles: any, coors: any, distanceThreshold: number) => any =
    // @ts-ignore
    cornerstoneTools.import("manipulators/getHandleNearImagePoint");
}
